export default "__VITE_ASSET__HapD56yY__"